/* eslint-disable @typescript-eslint/no-explicit-any */
import { VStack, HStack, Button } from '@chakra-ui/react';
import { useState } from 'react';
import { MainTemplate } from '../../templates/MainTemplate';
import { useTheme } from '../../contexts/ThemeProvider';
import { FaFrown } from 'react-icons/fa';
import { Label } from '../../components/atoms/Label';
import { CardNotification } from './components/CardNotifications';
import { useNavigate } from 'react-router-dom';
import { useNotificationsMutation } from '@/service/club/hooks';
import { INotificationItem } from '@/service/club/types';
import { OpenBookProvider } from '@/pages/Bookstore/contexts/BookContext';
import { BookstoreModuleProvider } from '@/pages/Bookstore/contexts/BookstoreModuleContext';
import { BookModal } from '@/pages/Bookstore/components/organisms/BookModal';
import { InfiniteScroll } from '@/pages/Bookstore/components/atoms/InfiniteScroll';

type ReadFilter = 'unread' | 'read' | 'all';
type TypeFilter = '' | 'book' | 'magazine' | 'audiobook' | 'magazine-partiu';

const FILTER_TABS: { key: ReadFilter; label: string }[] = [
  { key: 'all', label: 'Todas' },
  { key: 'unread', label: 'Não lidas' },
  { key: 'read', label: 'Lidas' },
];

const TYPE_TABS: { key: TypeFilter; label: string }[] = [
  { key: '', label: 'Tudo' },
  { key: 'book', label: 'Livros' },
  { key: 'magazine', label: 'Revistas' },
  { key: 'audiobook', label: 'Audiobooks' },
  { key: 'magazine-partiu', label: 'Revistas Partiu' },
];

export function NotificationPage() {
  const { id, colors, isNative } = useTheme();

  const navigation = useNavigate();
  const [filter, setFilter] = useState<ReadFilter>('all');
  const [typeFilter, setTypeFilter] = useState<TypeFilter>('');

  const onHandleClick = (discount: number) => {
    navigation(`/vantagens/detalhes/local/${discount}`);
  };

  const renderItem = (notification: INotificationItem) => (
    <VStack padding="0px 20px" width={'100%'} spacing={2}>
      <CardNotification
        notification={notification}
        onHandleClick={notification.discount ? () => onHandleClick(notification.discount as number) : undefined}
      />
    </VStack>
  );

  return (
    <MainTemplate>
      <BookstoreModuleProvider type="biblioteca">
        <OpenBookProvider isNative={!!isNative}>
          <BookModal />
          <VStack align={'self-start'} width="100%" marginBottom={'100px'} paddingTop={'20px'} spacing={4}>
            <HStack padding={'0px 20px'} alignSelf={'flex-start'}>
              <Label>Notificações</Label>
            </HStack>
            <HStack width="100%" padding={'0px 20px'} spacing={2} flexWrap={'wrap'} rowGap={2}>
              {FILTER_TABS.map((t) => (
                <Button
                  key={t.key}
                  size="sm"
                  borderRadius={'full'}
                  fontSize={'12px'}
                  variant={filter === t.key ? 'solid' : 'outline'}
                  backgroundColor={filter === t.key ? colors.primaryColor : 'transparent'}
                  borderColor={colors.primaryColor}
                  color={filter === t.key ? 'white' : colors.primaryColor}
                  _hover={{ opacity: 0.9 }}
                  onClick={() => setFilter(t.key)}
                >
                  {t.label}
                </Button>
              ))}
            </HStack>
            <HStack width="100%" padding={'0px 20px'} spacing={2} flexWrap={'wrap'} rowGap={2}>
              {TYPE_TABS.map((t) => (
                <Button
                  key={t.key || 'all'}
                  size="sm"
                  borderRadius={'full'}
                  fontSize={'12px'}
                  variant={typeFilter === t.key ? 'solid' : 'outline'}
                  backgroundColor={typeFilter === t.key ? colors.primaryColor : 'transparent'}
                  borderColor={colors.primaryColor}
                  color={typeFilter === t.key ? 'white' : colors.primaryColor}
                  _hover={{ opacity: 0.9 }}
                  onClick={() => setTypeFilter(t.key)}
                >
                  {t.label}
                </Button>
              ))}
            </HStack>
            <InfiniteScroll<INotificationItem>
              key={`${filter}-${typeFilter}`}
              mutationHook={useNotificationsMutation}
              renderItem={renderItem}
              keyExtraction={(notification) => String(notification.id)}
              requireCover={false}
              hookProps={{ agreement: id, limit: 10, read: filter, type: typeFilter }}
              emptyResultsComponent={
                <VStack width={'100%'} align={'center'} justify={'center'} spacing={5} paddingTop={'50px'}>
                  <FaFrown size="50px" color={colors.primaryColor} />
                  <Label textAlign={'center'}>
                    {filter === 'unread'
                      ? 'Nenhuma notificação não lida.'
                      : filter === 'read'
                        ? 'Nenhuma notificação lida ainda.'
                        : 'Nenhuma notificação disponível no momento.'}
                  </Label>
                  <Button
                    borderColor={colors.primaryColor}
                    variant="outline"
                    color={colors.primaryColor}
                    onClick={() => navigation('/vantagens')}
                  >
                    Ver vantagens
                  </Button>
                </VStack>
              }
            >
              {(items) => (
                <VStack width={'100%'} spacing={4}>
                  {items}
                </VStack>
              )}
            </InfiniteScroll>
          </VStack>
        </OpenBookProvider>
      </BookstoreModuleProvider>
    </MainTemplate>
  );
}
